import { BrandWordmark } from '@/components/shared/BrandLoadingScreen';
import { resolveAppLanguage, translateForLanguage } from '@/contexts/LanguageContext';
import { cn } from '@/lib/utils';

interface GlobalErrorFallbackProps {
  error: unknown;
  resetError?: () => void;
}

export function GlobalErrorFallback({ error }: GlobalErrorFallbackProps) {
  const language = resolveAppLanguage();
  const t = (key: string) => translateForLanguage(language, key);

  return (
    <div
      className={cn(
        'fixed inset-0 flex items-center justify-center px-4',
        'min-h-dvh h-dvh w-full',
        'bg-gradient-to-br from-background via-violet-50/50 to-indigo-50/40',
        'dark:from-background dark:via-violet-950/25 dark:to-indigo-950/20',
      )}
    >
      <div className="max-w-md w-full text-center space-y-6">
        <BrandWordmark />

        <div className="space-y-2">
          <h1 className="font-display text-xl font-semibold text-foreground">
            {t('errorBoundary.title')}
          </h1>
          <div className="text-sm text-muted-foreground leading-relaxed space-y-1">
            <p>{t('errorBoundary.body')}</p>
            <p>{t('errorBoundary.reloadHint')}</p>
          </div>
        </div>

        {import.meta.env.DEV && (
          <pre className="text-xs text-left bg-muted p-3 rounded overflow-auto max-h-40">
            {(error as Error)?.message}
          </pre>
        )}
      </div>
    </div>
  );
}
